import { useEffect, useState } from 'react'

import { TextField, Props as TextFieldProps } from './TextField'

type Props = Omit<TextFieldProps, 'mask' | 'value' | 'onChange' | 'onBlur'> & {
    value: number
    onChange: (newValue: number) => void
}

export const IntegerField = ({ value, onChange, onFocus, ...props }: Props) => {
    const [stringValue, setStringValue] = useState(value.toString())

    useEffect(() => {
        setStringValue(value.toString())
    }, [value])

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== 'Enter') {
            return
        }
        event.preventDefault()
        event.stopPropagation()
        event.currentTarget.blur()
    }

    return (
        <TextField
            {...props}
            value={stringValue}
            onChange={() => {
                // Intentionally left blank. This is handled by the onComplete event in the mask library.
            }}
            mask={[
                { mask: Number, scale: 0 },
                {
                    onComplete: (newStringValue) => setStringValue(newStringValue),
                },
            ]}
            onBlur={() => onChange(parseFloat(stringValue))}
            onFocus={(event) => {
                event.target.select()
                onFocus?.(event)
            }}
            onKeyDown={handleKeyDown}
        />
    )
}
